import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Services as ServicesV2 } from './v2';
import { ServicesContainer as ServicesV1 } from './v1';
import { selectRedesignServiceCardsExperiment } from '../../../../../../selectors/experiments';
import { selectIsServicesReloading } from '../../../../../../selectors/publishTerms';
import { ElementInViewport } from '../../../../../common/ElementInViewport';
import { useServicesAnalyticsHandlers } from './hooks';
import { ServicesLoaderMask } from './components';

export const ServicesContainer = () => {
  const isLoading = useSelector(selectIsServicesReloading);

  const showServicesV2 = useSelector(selectRedesignServiceCardsExperiment);
  const { onServicesShow, onDiffPricingShow } = useServicesAnalyticsHandlers();

  const handleServicesShows = useCallback(() => {
    onServicesShow();
    onDiffPricingShow();
  }, [onDiffPricingShow, onServicesShow]);

  return (
    <ElementInViewport threshold={0.25} onVisible={handleServicesShows}>
      <ServicesLoaderMask isLoading={isLoading}>{showServicesV2 ? <ServicesV2 /> : <ServicesV1 />}</ServicesLoaderMask>
    </ElementInViewport>
  );
};
